import { render, staticRenderFns } from "./commonPrompt.vue?vue&type=template&id=73864f68&scoped=true"
import script from "./commonPrompt.vue?vue&type=script&lang=js"
export * from "./commonPrompt.vue?vue&type=script&lang=js"
import style0 from "./commonPrompt.vue?vue&type=style&index=0&id=73864f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73864f68",
  null
  
)

export default component.exports